'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var defaultCharacter=exports.defaultCharacter='_',maskPreset=exports.maskPreset={d:'[0-9]',s:'[0-9.,\u0431\u044E]',a:'[a-z]',A:'[A-Z]',а:'[\u0430-\u044F]',А:'[\u0410-\u042F]',"*":'[0-9a-zA-Z\u0430-\u044F\u0410-\u042F]'};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/__utils/StringFunctions/Constants.js
// module id = 767
// module chunks = 0